import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import {
  Spinner,
  InputGroup,
  Input,
  Button,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useFetch } from "../Base/Hooks/basicFetch";
import { ENVIRONMENT, environments } from "../../Config/Environment";

import "./BasicForm.scss";
const BasicLogin = (props) => {
  const { updateState, intl, currentState } = props;
  const { formatMessage } = intl;
  const [credentials, setCredentials] = useState({
    username: null,
    password: null,
  });
  const [formError, setFormError] = useState(null);
  const [refreshFlag, setRefreshFlag] = useState(false);
  const [authKey, setAuthKey] = useState(null);
  const [queryString, setQueryString] = useState();

  const { error, loading, data } = useFetch(
    "/v1/client/fixtures?" + queryString,
    { method: "GET", values: null, key: authKey },
    refreshFlag
  );

  useEffect(() => {
    if (loading) {
      setRefreshFlag(false);
    }
    if (error && error.message) {
      setFormError(error.message);
      setRefreshFlag(false);
    }
    if (data) {
      if (data.data) {
        updateState("authKey", authKey);
        sessionStorage.setItem("authKey", authKey);
        setRefreshFlag(false);
      }
    }
    // eslint-disable-next-line
  }, [data, error, loading]);

  function handleCredentials(e, type) {
    let tempCredentials = credentials;
    tempCredentials[type] = e.target.value.trim();
    setCredentials(tempCredentials);
    if (tempCredentials.password && tempCredentials.username) {
      setFormError(null);
      setAuthKey(btoa(credentials.username + ":" + credentials.password));
    }
  }

  function doLogin() {
    setFormError(null);
    if (!credentials.password || !credentials.username) {
      setFormError("User Name or Password cannot be blank");
    } else {
      var dateFrom = new Date();
      dateFrom.setHours(dateFrom.getHours() - 4);
      var dateTo = new Date();
      dateTo.setHours(dateFrom.getHours() + 164);

      setQueryString(
        "fromUTC=" +
          dateFrom.toISOString().split(".")[0] +
          "&toUTC=" +
          dateTo.toISOString().split(".")[0]
      );
      setRefreshFlag(true);
    }
  }

  const onSubmit = (ev) => {
    ev.preventDefault();
    doLogin();
  };

  return (
    <form onSubmit={onSubmit}>
      <Container className="BasicLogin setup-page">
        <Row>
          <Col sm="12" md={{ size: 6, offset: 3 }}>
            <h3>
              {formatMessage({
                id: "login",
                defaultMessage: "Login",
              })}
            </h3>
            {currentState.globalErrorMessage && (
              <div className="login-error-message">
                {formatMessage({
                  id: currentState.globalErrorMessage,
                  defaultMessage: "Something went wrong",
                })}
              </div>
            )}
            {formError && <div className="formError">{formError}</div>}
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fas fa-user-tie"></i>
                </span>
              </div>
              <Input
                type="text"
                name=""
                className="form-control"
                placeholder={formatMessage({
                  id: "name.user",
                  defaultMessage: "User Name",
                })}
                onChange={(e) => handleCredentials(e, "username")}
              />
            </InputGroup>
            <br />
            <InputGroup>
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fa fa-key icon"></i>
                </span>
              </div>
              <Input
                type="Password"
                name=""
                className="form-control"
                placeholder={formatMessage({
                  id: "password",
                  defaultMessage: "Password",
                })}
                onChange={(e) => handleCredentials(e, "password")}
              />
            </InputGroup>
            <br />
            {!loading && (
              <Button type="submit" color="success" className="float-right">
                {formatMessage({
                  id: "login",
                  defaultMessage: "Login",
                })}
              </Button>
            )}
            {loading && <Spinner size="md" color="orange" />}
          </Col>
          <Col sm="12" md={{ size: 6, offset: 3 }}>
            <hr />
          </Col>
          <Col sm="12" md={{ size: 6, offset: 3 }}>
            <a
              href={
                "https://admin.ig." + environments["basedomain"][ENVIRONMENT]
              }
              className="admin-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              {formatMessage({
                id: "login.admin",
                defaultMessage: "Admin Login",
              })}
              <i className="fas fa-arrow-right"></i>
            </a>
          </Col>
        </Row>
      </Container>
    </form>
  );
};

export default injectIntl(BasicLogin);
